module.exports = __webpack_public_path__ + "img/mm.ab106c08.svg";